import * as React from "react";
import {
	Button,
	Menu,
	MenuItem,
	MenuItemCheckbox,
	MenuList,
	MenuPopover,
	MenuTrigger,
	Persona,
} from "@fluentui/react-components";
import { useCurrentUserPrincipal } from "../../../../services/UserServices/UserService";
import styles from "./CurrentUser.module.scss";
import { useContact, useCurrentUser } from "@/hooks/User";
import { useSuperUserContext } from "@/context/SuperUserContext";
export interface ICurrentUserProps {}

export function CurrentUser(props: ICurrentUserProps) {
	const { data: contact } = useCurrentUser();
	const ref = React.useRef<HTMLDivElement>(null);
	const { isSuperUser, hasSuperUserRole, setSuperUser, impersonatedUserId } = useSuperUserContext();
	const { data: impersonatedContact } = useContact(
		isSuperUser && impersonatedUserId ? impersonatedUserId : null
	);
	return (
		<div className={styles.currentUser}>
			<Menu
				positioning={"below-end"}
				checkedValues={{ superUser: isSuperUser ? ["isSuperUser"] : [] }}>
				<MenuTrigger disableButtonEnhancement>
					<Button appearance="subtle">
						<div className={styles.currentUserButtonInner}>
							<Persona
								ref={ref}
								size="large"
								avatar={{ color: "colorful" }}
								name={contact?.name ?? ""}
								primaryText={contact?.name}
								secondaryText={contact?.jobTitle ?? ""}></Persona>

							{impersonatedContact &&
								isSuperUser &&
								impersonatedUserId &&
								impersonatedUserId !== contact?.id && (
									<>
										<div>As</div>
										<Persona
											ref={ref}
											size="large"
											avatar={{ color: "colorful" }}
											name={impersonatedContact?.name ?? ""}
											primaryText={impersonatedContact?.name ?? ""}
											secondaryText={impersonatedContact?.jobTitle ?? ""}></Persona>
									</>
								)}
						</div>
					</Button>
				</MenuTrigger>
				<MenuPopover>
					<MenuList>
						{hasSuperUserRole && false && (
							<MenuItemCheckbox
								name="superUser"
								value="isSuperUser"
								onClick={() => setSuperUser(!isSuperUser)}>
								Super User
							</MenuItemCheckbox>
						)}
						<MenuItemCheckbox
							name="logOut"
							value="logOut"
							onClick={() => (window.location.href = "/.auth/logout")}>
							Logout
						</MenuItemCheckbox>
					</MenuList>
				</MenuPopover>
			</Menu>
		</div>
	);
}
